import React, { useState, useEffect } from "react";
import axios from "axios";
import Navbar from "../../Header/header";
import SASidebar from "../../Dashboard/SuperAdmin/Superadmincom/SuperAdminSidebar";
import { API_LoginURL } from "../../../config";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";
import { RotatingLines } from "react-loader-spinner";

export default function SchoolMaster() {
    // State management
    const [state, setState] = useState({
        schools: [],
        loading: true,
        formSubmitting: false,
        formData: {
            school_id: 0,
            school_name: "",
            city: "",
            state: "",
            schoolDetailStatus: true,
        },
        searchQuery: "",
        filterStatus: "all",
        currentPage: 0,
        itemsPerPage: 10,
    });

    // Helper function to update state
    const updateState = (newState) => {
        setState((prev) => ({ ...prev, ...newState }));
    };

    // Fetch data on component mount
    useEffect(() => {
        fetchSchools();
    }, []);

    useEffect(() => {
        console.log("STATE.FORMDATA =========== ", state.formData);
    }, [state]);

    // API calls
    const fetchSchools = async () => {
        updateState({ loading: true });
        try {
            const response = await axios.get(
                `${API_LoginURL}school/SchoolMasterList`,
                {
                    headers: getHeaders(),
                }
            );
            updateState({
                schools: Array.isArray(response.data) ? response.data : [],
                loading: false,
            });
        } catch (error) {
            console.error("Error fetching schools:", error);
            Swal.fire("Error!", "Failed to load schools.", "error");
            updateState({ loading: false });
        }
    };

    // Helper function for headers
    const getHeaders = () => ({
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("token"),
    });

    // Form handlers
    //changes done by sudeep 5/6/2025
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        let newValue = value;

        if (name === "schoolDetailStatus") {
            newValue = value === "true"; // Convert string to boolean
        }

        updateState({
            formData: {
                ...state.formData,
                [name]: newValue,
            },
        });
    };

    const handleSearchChange = (e) => {
        updateState({
            searchQuery: e.target.value,
            currentPage: 0,
        });
    };

    const handleFilterChange = (e) => {
        updateState({
            filterStatus: e.target.value,
            currentPage: 0,
        });
    };

    const resetForm = () => {
        updateState({
            formData: {
                school_id: 0,
                school_name: "",
                city: "",
                state: "",
                schoolDetailStatus: true,
            },
        });
    };

    const handleEdit = (school) => {
        updateState({ formData: school });
    };

    const handleDelete = async (school_id) => {
        const confirmation = await Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        });

        if (!confirmation.isConfirmed) return;

        try {
            await axios.post(
                `${API_LoginURL}school/DeleteSchoolDetails`,
                { schoolDetailsId: school_id },
                { headers: getHeaders() }
            );
            updateState({
                schools: state.schools.filter(
                    (school) => school.school_id !== school_id
                ),
            });
            Swal.fire("Deleted!", "School has been deleted.", "success");
        } catch (error) {
            console.error("Error deleting school:", error);
            Swal.fire("Error", "Failed to delete school", "error");
        }
    };

    const handlePageChange = ({ selected }) => {
        updateState({ currentPage: selected });
    };

    const handleFormSubmit = async () => {
        updateState({ formSubmitting: true });
        try {
            const response = await axios.post(
                `${API_LoginURL}school/SchoolAddEdit`,
                state.formData,
                { headers: getHeaders() }
            );

            Swal.fire({
                icon:
                    response.data.response === "SUCCESS" ? "success" : "error",
                title:
                    response.data.response === "SUCCESS" ? "Success" : "Error",
                text:
                    response.data.response === "SUCCESS"
                        ? "School saved successfully"
                        : response.data.response,
            });

            if (response.data.response === "SUCCESS") {
                fetchSchools();
                document.getElementById("close1234").click();
                resetForm();
            }
        } catch (error) {
            console.error("Error saving school:", error);
            Swal.fire("Error", "Failed to save school", "error");
        } finally {
            updateState({ formSubmitting: false });
        }
    };

    const handleFormSubmitIfEmpty = () => {
        if (
            state.formData.school_name === "" ||
            state.formData.school_name === null ||
            state.formData.city === "" ||
            state.formData.city === null ||
            state.formData.state === "" ||
            state.formData.state === null
        ) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "Fields May Not be Empty",
            });
        } else {
            handleFormSubmit();
        }
    };

    // Filter and pagination
    const filteredSchools = state.schools.filter((school) => {
        const matchesSearch =
            school.school_name
                .toLowerCase()
                .includes(state.searchQuery.toLowerCase()) ||
            school.city
                .toLowerCase()
                .includes(state.searchQuery.toLowerCase()) ||
            school.state
                .toLowerCase()
                .includes(state.searchQuery.toLowerCase());

        const matchesStatus =
            state.filterStatus === "all" ||
            (state.filterStatus === "active" && school.schoolDetailStatus) ||
            (state.filterStatus === "inactive" && !school.schoolDetailStatus);

        return matchesSearch && matchesStatus;
    });

    const pageCount = Math.ceil(filteredSchools.length / state.itemsPerPage);
    const displayedSchools = filteredSchools.slice(
        state.currentPage * state.itemsPerPage,
        (state.currentPage + 1) * state.itemsPerPage
    );

    return (
        <div className="container-scroller">
            <Navbar />
            <div className="container-fluid page-body-wrapper">
                <SASidebar />
                <div className="main-panel">
                    <div className="content-wrapper">
                        <div className="col-lg-12 grid-margin stretch-card">
                            <div className="card">
                                <div className="card-body">
                                    {/* Header Section */}
                                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-4">
                                        <h4 className="card-title mb-3 mb-md-0">
                                            School Master
                                        </h4>

                                        {/* Search and Filter */}
                                        <div className="d-flex flex-column flex-md-row align-items-center gap-3 w-100 w-md-auto">
                                            {/* Search */}
                                            <div
                                                className="flex-grow-1 me-md-2 position-relative"
                                                style={{ maxWidth: "500px" }}
                                            >
                                                <input
                                                    type="text"
                                                    className="form-control form-control-sm ps-5 rounded-pill border-0"
                                                    placeholder="Search by Name, Role or Number"
                                                    value={state.searchQuery}
                                                    onChange={
                                                        handleSearchChange
                                                    }
                                                    style={{
                                                        height: "38px",
                                                        boxShadow:
                                                            "0 2px 8px rgba(0,0,0,0.08)",
                                                        transition:
                                                            "all 0.3s ease",
                                                        backgroundColor:
                                                            "#f8f9fa", // Light background
                                                    }}
                                                    onFocus={(e) => {
                                                        e.target.style.boxShadow =
                                                            "0 2px 12px rgba(0,0,0,0.15)";
                                                        e.target.style.backgroundColor =
                                                            "#fff";
                                                    }}
                                                    onBlur={(e) => {
                                                        e.target.style.boxShadow =
                                                            "0 2px 8px rgba(0,0,0,0.08)";
                                                        e.target.style.backgroundColor =
                                                            "#f8f9fa";
                                                    }}
                                                />
                                                <i className="fas fa-search position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>

                                                {/* Optional clear button when text is entered */}
                                                {state.searchQuery && (
                                                    <button
                                                        className="btn btn-link position-absolute top-50 end-0 translate-middle-y me-2 p-0 text-muted"
                                                        onClick={() =>
                                                            handleSearchChange({
                                                                target: {
                                                                    value: "",
                                                                },
                                                            })
                                                        }
                                                        style={{
                                                            border: "none",
                                                            background:
                                                                "transparent",
                                                            fontSize: "12px",
                                                        }}
                                                    >
                                                        <i className="fas fa-times"></i>
                                                    </button>
                                                )}
                                            </div>

                                            {/* Filter */}
                                            {/* <div className="d-flex align-items-center">
                                                <i className="fas fa-filter me-2 text-muted"></i>
                                                <select
                                                    className="form-select"
                                                    value={state.filterStatus}
                                                    onChange={
                                                        handleFilterChange
                                                    }
                                                    style={{
                                                        minWidth: "120px",
                                                    }}
                                                >
                                                    <option value="all">
                                                        All Status
                                                    </option>
                                                    <option value="inactive">
                                                        Active
                                                    </option>
                                                    <option value="active">
                                                        InActive
                                                    </option>
                                                </select>
                                            </div> */}

                                            {/* Add School Button */}
                                            <button
                                                className="btn btn-primary d-flex align-items-center"
                                                data-bs-toggle="modal"
                                                data-bs-target="#schoolModal"
                                                onClick={resetForm}
                                            >
                                                <i className="fas fa-plus me-2"></i>
                                                <span className="d-none d-md-inline">
                                                    Add School
                                                </span>
                                            </button>
                                        </div>
                                    </div>

                                    {/* School Table */}
                                    <div className="table-responsive">
                                        {state.loading ? (
                                            <div
                                                className="d-flex justify-content-center align-items-center"
                                                style={{ height: "200px" }}
                                            >
                                                <RotatingLines
                                                    strokeColor="#4e73df"
                                                    strokeWidth="5"
                                                    animationDuration="0.75"
                                                    width="50"
                                                />
                                                <p className="mt-3 ms-3">
                                                    Loading schools...
                                                </p>
                                            </div>
                                        ) : (
                                            <>
                                                <table className="table table-hover table table-striped">
                                                    <thead className="table-primary">
                                                        <tr>
                                                            <th width="10%">
                                                                ID
                                                            </th>
                                                            <th width="30%">
                                                                School Name
                                                            </th>
                                                            <th width="20%">
                                                                City
                                                            </th>
                                                            <th width="20%">
                                                                State
                                                            </th>
                                                            {/* <th width="20%">
                                                                Status
                                                            </th> */}
                                                            <th
                                                                width="20%"
                                                                className="text-end"
                                                            >
                                                                Actions
                                                            </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {displayedSchools.length >
                                                        0 ? (
                                                            displayedSchools.map(
                                                                (school) => (
                                                                    <tr
                                                                        key={
                                                                            school.school_id
                                                                        }
                                                                    >
                                                                        <td>
                                                                            {
                                                                                school.school_id
                                                                            }
                                                                        </td>
                                                                        <td>
                                                                            {
                                                                                school.school_name
                                                                            }
                                                                        </td>
                                                                        <td>
                                                                            {
                                                                                school.city
                                                                            }
                                                                        </td>
                                                                        <td>
                                                                            {
                                                                                school.state
                                                                            }
                                                                        </td>
                                                                        {/* <td
                                                                            style={{
                                                                                color: school.schoolDetailStatus
                                                                                    ? "red"
                                                                                    : "green",
                                                                            }}
                                                                        >
                                                                            {school.schoolDetailStatus
                                                                                ? "Inactive"
                                                                                : "Active"}
                                                                        </td> */}

                                                                        <td className="text-end">
                                                                            <div className="d-flex justify-content-end gap-2">
                                                                                <button
                                                                                    className="btn btn-sm btn-outline-primary"
                                                                                    data-bs-toggle="modal"
                                                                                    data-bs-target="#schoolModal"
                                                                                    onClick={() =>
                                                                                        handleEdit(
                                                                                            school
                                                                                        )
                                                                                    }
                                                                                    title="Edit"
                                                                                >
                                                                                    <i className="fas fa-edit"></i>
                                                                                </button>
                                                                                <button
                                                                                    className="btn btn-sm btn-outline-danger"
                                                                                    onClick={() =>
                                                                                        handleDelete(
                                                                                            school.school_id
                                                                                        )
                                                                                    }
                                                                                    title="Delete"
                                                                                >
                                                                                    <i className="fas fa-trash"></i>
                                                                                </button>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            )
                                                        ) : (
                                                            <tr>
                                                                <td
                                                                    colSpan="5"
                                                                    className="text-center py-4"
                                                                >
                                                                    <div className="d-flex flex-column align-items-center">
                                                                        <img
                                                                            src="https://img.icons8.com/ios/50/000000/no-camera--v1.png"
                                                                            alt="No schools"
                                                                            style={{
                                                                                opacity: 0.5,
                                                                                width: "60px",
                                                                            }}
                                                                        />
                                                                        <p className="mt-3 text-muted">
                                                                            No
                                                                            schools
                                                                            found
                                                                        </p>
                                                                        <button
                                                                            className="btn btn-sm btn-primary mt-2"
                                                                            data-bs-toggle="modal"
                                                                            data-bs-target="#schoolModal"
                                                                            onClick={
                                                                                resetForm
                                                                            }
                                                                        >
                                                                            Add
                                                                            New
                                                                            School
                                                                        </button>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>

                                                {/* Pagination */}
                                                {displayedSchools.length >
                                                    0 && (
                                                    <ReactPaginate
                                                        previousLabel={
                                                            <i className="fas fa-chevron-left"></i>
                                                        }
                                                        nextLabel={
                                                            <i className="fas fa-chevron-right"></i>
                                                        }
                                                        pageCount={pageCount}
                                                        onPageChange={
                                                            handlePageChange
                                                        }
                                                        containerClassName={
                                                            "pagination justify-content-center mt-4"
                                                        }
                                                        pageClassName={
                                                            "page-item"
                                                        }
                                                        pageLinkClassName={
                                                            "page-link"
                                                        }
                                                        previousClassName={
                                                            "page-item"
                                                        }
                                                        previousLinkClassName={
                                                            "page-link"
                                                        }
                                                        nextClassName={
                                                            "page-item"
                                                        }
                                                        nextLinkClassName={
                                                            "page-link"
                                                        }
                                                        activeClassName={
                                                            "active"
                                                        }
                                                        breakLabel={"..."}
                                                        marginPagesDisplayed={2}
                                                        pageRangeDisplayed={5}
                                                        forcePage={
                                                            state.currentPage
                                                        }
                                                    />
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* School Modal */}
            <div
                className="modal fade"
                id="schoolModal"
                tabIndex="-1"
                aria-labelledby="schoolModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header bg-light">
                            <h5 className="modal-title" id="schoolModalLabel">
                                {state.formData.school_id > 0
                                    ? "Edit School"
                                    : "Add New School"}
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div className="modal-body">
                            <form>
                                <div className="mb-1 row">
                                    <label
                                        htmlFor="school_name"
                                        className="form-label required "
                                    >
                                        School Name
                                    </label>
                                    <div className="col-sm-9">
                                    <input
                                        type="text"
                                        className={`form-control ${
                                            state.formSubmitted &&
                                            !state.formData.school_name
                                                ? "is-invalid"
                                                : ""
                                        }`}
                                        id="school_name"
                                        name="school_name"
                                        value={state.formData.school_name}
                                        onChange={handleInputChange}
                                        required
                                    />
                                    {state.formSubmitted &&
                                        !state.formData.school_name && (
                                            <div className="invalid-feedback">
                                                School name is required
                                            </div>
                                        )}
                                </div>
                                </div>
                                <div className="mb-1 row">
                                    <label
                                        htmlFor="city"
                                        className="form-label required"
                                    >
                                        City
                                    </label>
                                    <div className="col-sm-9">
                                    <input
                                        type="text"
                                        className={`form-control ${
                                            state.formSubmitted &&
                                            !state.formData.city
                                                ? "is-invalid"
                                                : ""
                                        }`}
                                        id="city"
                                        name="city"
                                        value={state.formData.city}
                                        onChange={handleInputChange}
                                        required
                                    />
                                    {state.formSubmitted &&
                                        !state.formData.city && (
                                            <div className="invalid-feedback">
                                                City is required
                                            </div>
                                        )}
                                </div> 
                                </div>
                                <div className="mb-1 row">
                                    <label
                                        htmlFor="state"
                                        className="form-label required"
                                    >
                                        State
                                    </label>
                                    <div className="col-sm-9">
                                    <input
                                        type="text"
                                        className={`form-control ${
                                            state.formSubmitted &&
                                            !state.formData.state
                                                ? "is-invalid"
                                                : ""
                                        }`}
                                        id="state"
                                        name="state"
                                        value={state.formData.state}
                                        onChange={handleInputChange}
                                        required
                                    />
                                    {state.formSubmitted &&
                                        !state.formData.state && (
                                            <div className="invalid-feedback">
                                                State is required
                                            </div>
                                        )}
                                </div>
                                </div>
                                {/* {state.formData.school_id > 0 && (
                                    <div className="mb-3">
                                        <label
                                            htmlFor="schoolDetailStatus"
                                            className="form-label"
                                        >
                                            Status
                                        </label>
                                        <select
                                            className="form-select"
                                            id="schoolDetailStatus"
                                            name="schoolDetailStatus"
                                            value={
                                                state.formData
                                                    .schoolDetailStatus
                                            }
                                            onChange={handleInputChange}
                                        >
                                            <option value="true">Active</option>
                                            <option value="false">
                                                Inactive
                                            </option>
                                        </select>
                                    </div>
                                )} */}
                            </form>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                id="close1234"
                                className="btn btn-secondary"
                                data-bs-dismiss="modal"
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleFormSubmitIfEmpty}
                                // onClick={handleFormSubmit}
                                disabled={state.formSubmitting}
                            >
                                {state.formSubmitting ? (
                                    <>
                                        <span
                                            className="spinner-border spinner-border-sm me-2"
                                            role="status"
                                            aria-hidden="true"
                                        ></span>
                                        Submitting...
                                    </>
                                ) : (
                                    "Submit"
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
